<template>
  <el-menu :default-active="defaultActive" :unique-opened="true" router :collapse="isCollapse"
           :collapse-transition="false"
           background-color="#545c64" text-color="#fff">
    <div class="logo" @click="changeCollapse">
      <el-image v-show="!isCollapse" :src="logoExpanded" style="width: 180px;" class="logo-image"></el-image>
      <el-image v-show="isCollapse" :src="logoCollapsed" style="width: 40px;" class="logo-image"></el-image>
    </div>
    <!--默认将首页放在第一位-->
    <el-menu-item route="/home" index="首页" @click="openTab('首页', '/home')" :style="{'margin-left': isCollapse ? '0px' : '20px'}">
      <i :class="['icon-color', 'iconfont icon-shouye']" style="margin-right: 10px" ></i><span>首页</span>
    </el-menu-item>
    <menu-tree :style="{'margin-left': isCollapse ? '0px' : '20px'}" :menu-data="menuList"></menu-tree>
  </el-menu>
</template>

<script>
import store from "../../store";
import {getDictionary, getMenuTree, getPermission} from "@/api/sys/menu/sysMenu";
import MenuTree from "../../components/MenuTree";
import Vue from "vue";

export default {
  name: "Aside",
  components: {
    MenuTree
  },
  data() {
    return {
      menuList: [],
      isCollapse: false,
      logoExpanded: require('../../assets/image/logo3.png'),
      logoCollapsed: require('../../assets/image/logo4.png')
    }
  },
  computed: {
    defaultActive: {
      get: function () {
        return store.state.activeIndex
      }
    }
  },
  mounted() {
    this.getMenuTree()
    this.getPermission()
    this.getDictionary()
  },
  methods: {
    // 获取当前用户菜单树
    getMenuTree() {
      getMenuTree().then(res => {
        this.menuList = res
        let allNodes = this.getAllNodes(this.menuList);
        store.dispatch('routerAction', allNodes)
      })
    },
    getAllNodes(tree) {
      let nodes = [];

      function recurse(currentNode) {
        nodes.push(currentNode);
        if (currentNode.children && currentNode.children.length > 0) {
          currentNode.children.forEach(child => recurse(child));
        }
      }

      tree.forEach(node => recurse(node));
      return nodes;
    },
    // 获取当前用户的按钮权限列表
    getPermission() {
      getPermission().then(res => {
        store.dispatch('permissionAction', res)
      })
    },
    // 获取当前用户的按钮权限列表
    getDictionary() {
      getDictionary().then(res => {
        Vue.prototype.$dict.load(res)
      })
    },
    // 打开页面
    openTab(name, path) {
      // 将当前打开的菜单添加到已打开列表中
      store.dispatch('addTabAction', {name: name, path: path})
      // 将激活菜单改成选中的菜单
      store.dispatch('activeIndexAction', name)
    },
    changeCollapse() {
      this.isCollapse = !this.isCollapse
      if (this.isCollapse) {
        this.$emit('update:width', '64px')
      } else {
        this.$emit('update:width', '230px')
      }
    }
  }
}
</script>

<style scoped>
.el-menu {
  height: 100%;
}

.logo {
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 20px;
  height: 60px;
  cursor: pointer;
}

/*.logo-image {
  transition: width 0.15s ease, opacity 0.15s ease;
}*/
/* 设置 <i> 标签的颜色 */
.icon-color {
  color: #ffffff; /* 你可以根据需要更改颜色 */
}

/* 取消 el-menu-item 激活状态下的颜色设置 */
.el-menu-item.is-active .icon-color {
  color: inherit; /* 或者设置为其他颜色 */
}
</style>
